export default {

    'CORP_SIGNUP':'사업자 회원 가입',
    'CORP_COUNTRY':'국가',
    'PLEASE_SELECT_COUNTRY_CORP_LOCATED':'사업자 등록지 기준 국가를 선택하시기 바랍니다.',
    'CORP_NAME':'회사명',
    'CORP_BRN':'사업자 번호',
    'CORP_ADDRESS':'주소',
    'CORP_TEL':'전화 번호',
    'CORP_BRN_FILE':'사업자 등록증 사진 또는 이미지 파일',
    'CORP_CEO_NAME':'대표자 성명',
    'CORP_ADMIN_NAME':'관리자 성명',
    'CORP_ADMIN_POSITION':'관리자 직위',
    'CORP_ADMIN_EMAIL':'관리자 로그인 이메일',
    'CORP_ADMIN_PASSWORD':'관리자 로그인 패스워드',
    'CORP_ADMIN_PASSWORD_CONFIRM':'관리자 로그인 패스워드 (확인)',
    'CORP_ADMIN_MOBILE_NUMBER':'관리자 휴대폰 번호',
    'PLEASE_SELECT_BRN_IMAGE_FILE':'사업자 등록증 이미지 파일을 선택하시기 바랍니다.',

    'INVALID_CORP_CODE_FORMAT':'기업 코드 형식에 오류가 있습니다.',
    'CORP_CODE_IS_REQUIRED':'기업 코드를 입력하시기 바랍니다.',
    'INVALID_EMAIL_FORMAT':'이메일 형식에 오류가 있습니다.',
    'EMAIL_IS_REQUIRED':'이메일을 입력하시기 바랍니다.',
    'PASSWORD_IS_REQUIRED':'패스워드를 입력하시기 바랍니다.',
    'INVALID_PASSWORD_FORMAT':'패스워드는 6자 이상, 40자 이하로 입력하시기 바랍니다.',
    'CORP_ADMIN_USER_LOGIN':'기업 회원 관리자 로그인',
    'CORP_CODE':'기업 코드',
    'EMAIL':'이메일',
    'PASSWORD':'패스워드',
    'LOGIN':'로그인',
    'FORGOT_PASSWORD':'패스워드를 잊으셨나요?',
    'FORGOT_CORP_CODE':'기업 코드를 잊으셨나요?',
    'CONFIRM':'확인',
    'PAGE_NOT_FOUND':'요청하신 페이지가 없습니다.',



    'DASHBOARD':'대시보드',



    'NEXT':'다음으로',
};

//export default Strings;